var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "rounded-lg" },
    [
      _c("v-card-title", [_vm._v(" Reports ")]),
      _c("v-divider"),
      _c(
        "v-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { staticClass: "pa-4", attrs: { cols: "12", sm: "5" } },
                [
                  _c(
                    "v-menu",
                    {
                      ref: "startMenu",
                      attrs: {
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        "offset-y": "",
                        "min-width": "auto",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        value: _vm.formattedStartDate,
                                        label: "Start Date",
                                        "prepend-icon": "mdi-calendar",
                                        readonly: "",
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.updateStartDate(
                                            $event.target.value
                                          )
                                        },
                                      },
                                    },
                                    "v-text-field",
                                    attrs,
                                    false
                                  ),
                                  on
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.startMenu,
                        callback: function ($$v) {
                          _vm.startMenu = $$v
                        },
                        expression: "startMenu",
                      },
                    },
                    [
                      _c("v-date-picker", {
                        attrs: { "no-title": "" },
                        on: {
                          input: (date) => {
                            _vm.startMenu = false
                            _vm.start_date = date
                          },
                        },
                        model: {
                          value: _vm.start_date,
                          callback: function ($$v) {
                            _vm.start_date = $$v
                          },
                          expression: "start_date",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "pa-4", attrs: { cols: "12", sm: "5" } },
                [
                  _c(
                    "v-menu",
                    {
                      ref: "endMenu",
                      attrs: {
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        "offset-y": "",
                        "min-width": "auto",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  _vm._b(
                                    {
                                      attrs: {
                                        value: _vm.formattedEndDate,
                                        label: "End Date",
                                        "prepend-icon": "mdi-calendar",
                                        readonly: "",
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.updateEndDate(
                                            $event.target.value
                                          )
                                        },
                                      },
                                    },
                                    "v-text-field",
                                    attrs,
                                    false
                                  ),
                                  on
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.endMenu,
                        callback: function ($$v) {
                          _vm.endMenu = $$v
                        },
                        expression: "endMenu",
                      },
                    },
                    [
                      _c("v-date-picker", {
                        attrs: { "no-title": "" },
                        on: {
                          input: (date) => {
                            _vm.endMenu = false
                            _vm.end_date = date
                          },
                        },
                        model: {
                          value: _vm.end_date,
                          callback: function ($$v) {
                            _vm.end_date = $$v
                          },
                          expression: "end_date",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "px-4 pt-8 pb-4",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.loadRecordings()
                        },
                      },
                    },
                    [_vm._v("Go")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.users.length > 0
            ? _c("v-card-subtitle", [
                _vm._v(
                  "Total Duration: " +
                    _vm._s(_vm.totalDuration) +
                    " (" +
                    _vm._s(
                      _vm.formatToDollars((_vm.totalDuration / 60) * 0.0135)
                    ) +
                    ") "
                ),
                _c("small", [_vm._v("*dollar amounts are estimates")]),
              ])
            : _vm._e(),
          _vm.users.length
            ? _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  loading: _vm.loading,
                  headers: _vm.headers,
                  items: _vm.users,
                  "items-per-page": 50,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item.average_duration",
                      fn: function ({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatDuration(item.average_duration)
                              ) +
                              " (" +
                              _vm._s(
                                _vm.formatToDollars(
                                  (item.average_duration / 60) * 0.0135
                                )
                              ) +
                              ") "
                          ),
                        ]
                      },
                    },
                    {
                      key: "item.total_duration",
                      fn: function ({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDuration(item.total_duration)) +
                              " (" +
                              _vm._s(
                                _vm.formatToDollars(
                                  (item.total_duration / 60) * 0.0135
                                )
                              ) +
                              ") "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3554217864
                ),
              })
            : _c("div", { staticClass: "text-h5 text--disabled text-center" }, [
                _vm._v("No Recordings"),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }